import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PersonalizeProductComponent } from './../../modules/modals/personalize-product/personalize-product.component';
import { OrdersService } from './../../services/order/orders.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PdvService } from './../../services/pdv/pdv.service';
import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'product',
    templateUrl: 'product.component.html',
    styleUrls: ['product.component.scss']
})
export class ProductComponent {
    @Input()
    product;
    loadAvatar = false;
    hover = false;
    siteClose = false;
    src: any;
    zoom: boolean = false;
    circle = false;
    compositions: any[] = [];
    bsModalRef: BsModalRef;
    @ViewChild('template') template: ElementRef;
    chosenOrderType: number;
    subscriptions2: Subscription[] = [];
    constructor(
        private pdvService: PdvService,
        private modalService: BsModalService,
        private orderService: OrdersService,
        private router: Router
    ) {
        const sub1 = this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
            }
        )
        const sub2 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
        this.subscriptions2.push(sub1, sub2);
    }
    displayComp() {
        this.hover = !this.hover;
    }
    zoomImg() {
        this.zoom = !this.zoom;
    }
    showComposition() {
        this.compositions = this.product.comp.split(",");
        this.bsModalRef = this.modalService.show(this.template, { class: "composition-modal" });
    }
    openImage(src) {
        this.src = src;
        var modal = <HTMLElement>document.getElementById('myModal');
        modal.style.display = "block";
    }


    closemodel() {
        if (this.bsModalRef) {
            this.bsModalRef.hide();
        }
    }

    addToBasket() {
        if (this.product.comp || this.product.maxNbrIngOptions > 0 || this.product.hasSupp) {
            this.PersonalizeModal();
        } else {
            this.addElementToBasket();
        }
    }

    PersonalizeModal() {
        if (this.chosenOrderType > 0) {
            this.bsModalRef = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.bsModalRef.content.product = this.product;
        } else {
            this.router.navigate(["/modes"], { queryParams: { famille: this.product.slug } });

        }
    }

    addElementToBasket() {
        if (this.chosenOrderType > 0) {
            let product = JSON.parse(JSON.stringify(this.product));
            let element = {
                id: product.id,
                code: product.code,
                name: product.name,
                family: product.family,
                size: product.sizes[product.size],
                comment: '',
                qty: 1,
                removedCompositions: [],
                supplements: [],
                optionIngredients: [],
                total: 0,
                vat: product.vat,
                priceSuppApp: product.priceSuppApp,
                priceWithSupp: Number(product.sizes[product.size].price),
                maxNbrIngOptions: product.maxNbrIngOptions,
                hasSupp: product.hasSupp
            }
            element.total += Number(element.size.price);
            element.total *= Number(element.qty);
            this.orderService.addElementToOrder(element);
        } else {
            this.router.navigate(["/modes"], { queryParams: { famille: this.product.slug } });
        }
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }
}
